export default __webpack_public_path__ + "static/media/buon.45348d58.png";